import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  name: PropTypes.string,
  address_line_1: PropTypes.string,
  address_line_2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  post_code: PropTypes.string,
  country: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
};

const AddressItem = ({ address }) => {
  return (
    <div className="account-card-address-item">
      <p className="text-dark text-extra-bold mb-1">{address.name}</p>
      <p className="text-sm text-light mb-0">{address.address_line_1}</p>
      <p className="text-sm text-light mb-0">{address.address_line_2}</p>
      <p className="text-sm text-light mb-0">
        {[address.city, address.state, address.post_code].join(', ')}
      </p>
      <p className="text-sm text-light mb-0">{address.country?.name}</p>
    </div>
  );
};

AddressItem.propTypes = propTypes;

export default AddressItem;
